// extracted by mini-css-extract-plugin
module.exports = {"original-price":"DisplayDiscountPrice_original-price__F5tgu","discountprice":"DisplayDiscountPrice_discountprice__tpXQp"};